/* Мост между hero и подбором: два ряда реплик, которыми хаос звучит вживую, плывут навстречу друг другу.
   Человек узнаёт свою фразу ещё до выбора ситуации в подборе. Это реплики и привычки, не факты о клиентах.
   Тексты: copy-marquee (copywriter-ru). Края растворяются маской, границ нет. Ряды декоративные: скринридеру
   они не нужны, а удвоенный список читался бы дважды. */
const ROW_A = [
  "опять тот же вопрос",
  "отзывы разберу вечером",
  "в какой это таблице?",
  "напомни клиенту про запись",
  "наговорил, вечером оформлю",
  "каталог пришлю файлом в чат",
];
const ROW_B = [
  "где письмо с условиями?",
  "кинь в личку, я потом гляну",
  "отчёт соберу к пятнице",
  "кто там написал в Telegram?",
  "сам не вижу, где просело",
  "сейчас посчитаю и напишу",
];

const Row = ({ items, className }) => (
  <div className="marquee-mask overflow-hidden">
    <div className={`flex w-max gap-3 ${className}`}>
      {[...items, ...items].map((label, i) => (
        <span
          key={i}
          className="inline-flex items-center gap-3 whitespace-nowrap rounded-full glass-lite px-5 py-3 text-base text-muted"
        >
          <i className="h-1.5 w-1.5 rounded-full bg-accent shadow-[0_0_10px_rgba(62,139,255,0.9)]" />
          {label}
        </span>
      ))}
    </div>
  </div>
);

export const TaskMarquee = () => (
  <div className="relative -mt-6 flex flex-col gap-3 pb-4" aria-hidden="true">
    <p className="eyebrow mb-3 text-center">Звучит знакомо</p>
    <Row items={ROW_A} className="marquee-track" />
    <Row items={ROW_B} className="marquee-track-rev" />
  </div>
);
